// @ts-nocheck
/** Gateway form fields — IPv4 regex, alpha-only OS, numeric caps. */
import { useState, useEffect } from 'react';
import { API_DATA_CENTER_LIST } from '@/service/url';
import { SERVER_TYPES } from '@/utilities/constant';
import { getApiCall } from '@/service/httpCall';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const Star = () => <span className="ml-0.5 text-destructive">*</span>;

function Field({ label, children, error }: any) {
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-foreground">
        {label} <Star />
      </label>
      {children}
      {error ? <div className="text-xs text-destructive">{error}</div> : null}
    </div>
  );
}

export default function RenderServerManagementForm(props: any) {
  const [dataCenterList, setDataCenterList] = useState<any[]>([]);
  const [ipError, setIpError] = useState('');

  useEffect(() => {
    getApiCall(API_DATA_CENTER_LIST, {})
      .then(setDataCenterList)
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <Field label="Data Center">
        <Select
          value={props.dataCenterId ? String(props.dataCenterId) : undefined}
          onValueChange={(v) => props.setDataCenterId(v)}
        >
          <SelectTrigger className="h-10 w-full">
            <SelectValue placeholder="Select data center…" />
          </SelectTrigger>
          <SelectContent>
            {dataCenterList.map((val: any) => (
              <SelectItem key={val.id} value={String(val.id)}>
                {val.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>

      <Field label="Gateway Type">
        <Select
          value={
            props.serverType !== '' && props.serverType != null
              ? String(props.serverType)
              : undefined
          }
          onValueChange={(v) => props.setServerType(v)}
        >
          <SelectTrigger className="h-10 w-full">
            <SelectValue placeholder="Select gateway type…" />
          </SelectTrigger>
          <SelectContent>
            {SERVER_TYPES.map((val: any) => (
              <SelectItem key={val.value} value={String(val.value)}>
                {val.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>

      <Field label="Gateway IP" error={ipError}>
        <Input
          type="text"
          value={props.serverIP}
          placeholder="Gateway IP (e.g. 192.168.1.1)"
          onChange={(e) => {
            const value = e.target.value;
            if (/^[0-9.]*$/.test(value)) {
              props.setServerIP(value);
              if (ipError) setIpError('');
            }
          }}
          onBlur={() => {
            const ipRegex =
              /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
            if (props.serverIP && !ipRegex.test(props.serverIP.trim())) {
              setIpError('Invalid IPv4 address');
            } else {
              setIpError('');
            }
          }}
        />
      </Field>

      <Field label="Gateway Name" error={props.error}>
        <Input
          type="text"
          value={props.serverName}
          placeholder="Gateway Name"
          onChange={props.handleChange}
        />
      </Field>

      <Field label="OS">
        <Input
          type="text"
          value={props.OS}
          placeholder="OS"
          onChange={(e) => {
            const value = e.target.value;
            if (/^[A-Za-z]*$/.test(value)) {
              props.setOS(value);
            }
          }}
        />
      </Field>

      <Field label="CPU Cores">
        <Input
          type="text"
          value={props.CPUCores}
          placeholder="CPU Cores (Max 999)"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '');
            if (Number(value) < 1000) {
              props.setCPUCores(value);
            }
          }}
        />
      </Field>

      <Field label="RAM">
        <Input
          type="text"
          value={props.RAM}
          placeholder="RAM (Max 999 GB)"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '');
            if (Number(value) < 1000) {
              props.setRAM(value);
            }
          }}
        />
      </Field>

      <Field label="Hard Disk">
        <Input
          type="text"
          value={props.hardDisk}
          placeholder="Hard Disk (Max 5000 GB)"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '');
            if (Number(value) <= 5000) {
              props.setHardDisk(value);
            }
          }}
        />
      </Field>
    </div>
  );
}
